<div class="fp-dialog">
  <div class="fp-header">
    <h2 mat-dialog-title>Recuperar contraseña</h2>
    <button mat-icon-button mat-dialog-close class="fp-close" [disabled]="isLoading">
      <span class="material-symbols-outlined">close</span>
    </button>
  </div>

  <mat-dialog-content class="fp-body">
    <p class="fp-subtitle">
      Introduce tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
    </p>

    <ng-container *ngIf="!successSent; else successTpl">
      <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
        <div class="form-field">
          <label for="fp-email" class="field-label">Correo electrónico</label>
          <div class="input-wrapper">
            <span class="material-symbols-outlined field-icon">mail</span>
            <input
              type="email"
              id="fp-email"
              formControlName="email"
              placeholder="tu@empresa.com"
              class="field-input"
              [class.field-error]="forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched"
            />
          </div>
          <span class="error-msg"
            *ngIf="forgotForm.get('email')?.invalid && forgotForm.get('email')?.touched">
            Introduce un correo electrónico válido.
          </span>
        </div>

        <button type="submit" class="submit-btn" [disabled]="isLoading || forgotForm.invalid">
          <span *ngIf="!isLoading">Enviar instrucciones</span>
          <mat-spinner *ngIf="isLoading" diameter="20" color="accent"></mat-spinner>
        </button>
      </form>
    </ng-container>

    <ng-template #successTpl>
      <div class="success-block">
        <span class="material-symbols-outlined success-icon">mark_email_read</span>
        <p class="success-title">¡Correo enviado!</p>
        <p class="success-desc">
          Si el correo está registrado, recibirás un enlace para restablecer tu contraseña en unos minutos.
          Revisa también tu carpeta de spam.
        </p>
        <button class="submit-btn" mat-dialog-close>Cerrar</button>
      </div>
    </ng-template>
  </mat-dialog-content>
</div>
